import React from 'react';

interface ColumnHeader {
  field?: string;
  header: string;
  headerClassName?: string;
  headerStyle?: React.CSSProperties;
  sortable?: boolean;
  selectionMode?: string;
  showAvatar?: boolean;
}

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  showPaginator?: boolean;
  className?: string;
  headers?: ColumnHeader[];
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({
  rows = 10,
  columns = 8,
  showPaginator = true,
  className = '',
  headers = [],
}) => {
  const actualColumns = headers.length > 0 ? headers.length : columns;

  return (
    <div
      className={`minthr-table minthr-mobile-table dataTable no-footer ${className}`}
    >
      <div className="p-datatable p-component">
        <div className="p-datatable-wrapper">
          <table className="minthr-table minthr-mobile-table dataTable no-footer p-datatable-table minthr-px-1">
            {headers.length > 0 && (
              <thead className="p-datatable-thead">
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      className={`p-datatable-column ${header.headerClassName || ''}`}
                      style={header.headerStyle}
                    >
                      {header.selectionMode === 'multiple' ? (
                        <div
                          className="p-column-header-content"
                          data-pc-section="headercontent"
                        >
                          <span
                            className="p-column-title"
                            data-pc-section="headertitle"
                          ></span>
                          <div
                            className="p-checkbox p-component p-disabled"
                            data-p-highlight="false"
                            data-p-disabled="true"
                            role="checkbox"
                            aria-checked="false"
                            aria-label="All items unselected"
                            data-pc-name="checkbox"
                            data-pc-section="root"
                          >
                            <input
                              className="p-checkbox-input"
                              aria-invalid="false"
                              aria-checked="false"
                              aria-label="All items unselected"
                              data-pc-section="input"
                              type="checkbox"
                            />
                            <div
                              className="p-checkbox-box"
                              data-p-highlight="false"
                              data-p-disabled="true"
                              data-pc-section="box"
                            ></div>
                          </div>
                        </div>
                      ) : (
                        <span className="p-column-title">{header.header}</span>
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
            )}
            <tbody className="p-datatable-tbody">
              {Array.from({ length: rows }, (_, rowIndex) => (
                <tr key={rowIndex} role="row">
                  {Array.from({ length: actualColumns }, (_, colIndex) => (
                    <td
                      key={colIndex}
                      role="cell"
                      className={`${headers[colIndex]?.headerClassName || ''} ${
                        headers[colIndex]?.showAvatar
                          ? 'skeleton-avatar-cell'
                          : ''
                      }`}
                    >
                      <div className="skeleton-content"></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showPaginator && (
          <div className="skeleton-paginator">
            <div className="skeleton-pagination-info">
              <div className="skeleton-content"></div>
            </div>
            <div className="skeleton-pagination-controls">
              <div className="skeleton-content"></div>
              <div className="skeleton-pagination-buttons">
                <div className="skeleton-content"></div>
                <div className="skeleton-content"></div>
                <div className="skeleton-content"></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableSkeleton;
